import { UserStore } from "@store/modules/user";

let renderRequester: ((visible: boolean) => void) | null = null;

export function registerTurnstileRenderRequester(
  requester: ((visible: boolean) => void) | null,
) {
  renderRequester = requester;
}

export function notifyTurnstileSuccess(token: string) {
  UserStore.turnstileToken = token;
  renderRequester?.(false);
}

export function notifyTurnstileError(_error: unknown) {
  renderRequester?.(false);
}
